import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("affaire_log JS en cours ...");
        super.connect();
        // add your code here, if applicable

        if ($("#search").length && $("#quick_sort").length) {

            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });

            this.handleSidebarScroll("affaire_log_");
            this.handleSidebarScroll("affaire_log_");
        }

    }


    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}

